import { render } from "./DeviceManagePage.vue?vue&type=template&id=6ef17d67&scoped=true"
import script from "./DeviceManagePage.vue?vue&type=script&lang=js"
export * from "./DeviceManagePage.vue?vue&type=script&lang=js"

import "./DeviceManagePage.vue?vue&type=style&index=0&id=6ef17d67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef17d67"]])

export default __exports__